<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
var height_1 = 0;
var height_2 = 0;
jQuery(".menu-flex.menu-banner").each(function(indx){
    var _height = jQuery(this).children(".menu-inner").find("h3").height();
    var _height2 = jQuery(this).children(".menu-inner").find("p").height();
    if(parseInt(_height) > parseInt(height_1)){
        height_1 = parseInt(_height);
    }
    if(parseInt(_height2) > parseInt(height_2)){
        height_2 = parseInt(_height2);
    }
});

jQuery(".menu-flex.menu-banner").each(function(indx){
    jQuery(this).children(".menu-inner").find("h3").height(height_1);    
    jQuery(this).children(".menu-inner").find("p").height(height_2);    
    // jQuery(this).children(".menu-inner").find("h3").css({background: "#f0f"});
    jQuery(this).children(".menu-inner").find("p").css({display: "block"});
});